import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const spaces = {
  popular_spaces: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/spaces/popular_spaces", params),
  posts: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/spaces/posts", params),
  comments: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/spaces/comments", params),
};
